import IconProps from './icon';

export const IconArrow = (props: IconProps) => {
  return (
    <svg
      className={props.className}
      viewBox="0 0 17 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.63918 9.81744L16.4795 2.09159L14.5421 0.182502L8.63918 5.99926L2.73625 0.182501L0.798876 2.09159L8.63918 9.81744Z"
        fill={props.color || "currentColor"}
      />
    </svg>
  );
};

export default IconArrow;
